import BrainImg from "components/shared/BrainImg";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import classNames from "utilities/ClassNames";
import { appear } from "./config/appear";
import { slide } from './config/slide';
import { SideMenuProps } from "./domain/types";
import { getExtractedPath } from "utilities/extractedPath";

const SideMenu: React.FC<SideMenuProps> = ({ closeMenu, showSideMenu, navLinks, hooks }) => {
  const { useApp, useScreen } = hooks;
  const { updateDashboardWidgets, dashboardWidgets, userRole } = useApp();
  const { isScaled } = useScreen();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [shouldRefresh, setShouldRefresh] = useState(false);

  const baseUrl = getExtractedPath();

  useEffect(() => {
    if (shouldRefresh) {
      setShouldRefresh(false);
      navigate("/");
    }
  }, [shouldRefresh, navigate]);

  return (
    <motion.div
      initial="exit"
      animate={showSideMenu ? "enter" : "exit"}
      variants={appear}
      className="fixed z-40 inset-0 w-full bg-black/90"
      onClick={closeMenu}
    >
      <motion.div
        initial="exit"
        animate={showSideMenu ? "enter" : "exit"}
        variants={slide}
        className={classNames(
          "xl-2xl:w-[330px] 2xl:w-[350px]",
          "absolute h-full left-0 top-0 z-20 bg-gray"
        )}
      >
        <div className="h-full w-full mt-20 pb-20 flex flex-col justify-between">
          <ul className="flex flex-col">
            {navLinks(isScaled).map((navLink: any, index: number) =>
              !(
                (userRole !== "admin" && navLink.text === "Logs")
              ) && (
                <NavLink
                  key={index}
                  to={navLink.to}
                  onClick={(event) => {
                    if (pathname === "/3d-dashboard") {
                      const readyLink = navLink.isExternal ? navLink.to : `${baseUrl}${navLink.to}`;

                      if (navLink.isExternal) {
                        // Hard redirect to external link
                        window.location.href = readyLink;
                      } else if (window.vuplex) {
                        navigate(navLink.to);
                      } else {
                        window.open(readyLink, "_blank");
                      }

                      event.preventDefault();
                      return;
                    }

                    if (navLink.isExternal) {
                      window.location.href = navLink.to;
                      event.preventDefault();
                      return;
                    }

                    if (navLink.text === "Dashboard Configuration") {
                      closeMenu();
                      updateDashboardWidgets({
                        ...dashboardWidgets,
                        selectedType: "init",
                      });
                    } else {
                      navigate(navLink.to);
                    }
                  }}
                  className={({ isActive }) => {
                    const baseClasses = `flex items-center gap-5 w-full border-b border-b-slate last:border-b--0 bg-transparent ${isScaled ? "p-1.5" : "p-3"}`;
                    const activeClasses = `bg-gradient-to-r from-green to-blue font-bold`;
                    const hoverClasses = `hover:bg-black duration-300`;

                    return isActive ? `${baseClasses} ${activeClasses}` : `${baseClasses} ${hoverClasses}`;
                  }}
                >
                  {navLink.icon}
                  <span className={"2xl:text-base xl-2xl:text-sm xl:text-xs"}>
                    {navLink.text}
                  </span>
                </NavLink>
              )
            )}
          </ul>
          <div className="grid place-content-center">
            <BrainImg />
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default SideMenu;
